<div class="row m-0">
  <div class="col-md-12 m-0 p-0">
    <div class="float-start w-100" style=" -webkit-user-select: none; -webkit-app-region: drag;">&nbsp;
    </div>
    <div class="float-end">
      <div class="d-flex">
        <div class="btn-group me-2" role="group" aria-label="Third group" *ngIf="yfAuth.getUser()">
          <button type="button" class="btn btn-sm btn-outline-success text-dark hover-nothing"
            style="border-radius: 15px;">Welcome, {{getLoggedInUser()}}</button>
        </div>
        <button class="btn btn-sm btn-warning me-2" routerLink="home"> Home </button>
        <button class="btn btn-sm btn-warning me-2" *ngIf="!version" (click)="openAppDownloadModal()"> Download Tools
        </button>
        <div class="btn-group" role="group" aria-label="Third group" (click)="logout()">
          <button type="button" class="btn btn-sm btn-danger" aria-label="Sign out">
            <i class="far fa-sign-out-alt" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>